import React, { useState, useEffect } from "react";
import styled from "styled-components";
import clientConfiguration from "../client-configuration";
import Cookies from "js-cookie";
import { EmailSubscribeForm } from "../components/forms/email-subscribe-form";
import { CookieKeys } from "../util/cookie";
import { CampaignApi } from "../lib-api/apis/CampaignApi";
import { apiConfiguration } from "../api-configuration";
import { CampaignBookingDto } from "../lib-api";
import { createRoot, Root } from "react-dom/client";

const SlideUpContainer = styled("div")({
  position: "fixed",
  zIndex: 20,
  left: 0,
  right: 0,
  top: 0,
  transition: "linear 0.1s",
  pointerEvents: "none",
});

const BoxContainer = styled.div({
  margin: "auto",
  maxWidth: "400px",
});

const SlideUpBox = styled.div({
  backgroundColor: "white",
  pointerEvents: "all",
  border: "1px solid #333",
  position: "relative",
  marginLeft: "25px",
  marginRight: "25px",
});

const CornerIcon = styled.div({
  border: "0",
  borderRadius: "50%",
  backgroundColor: "#D03822",
  color: "#FFF",
  padding: "10px",
  position: "absolute",
  top: "-30px",
  left: "-30px",
  fontSize: "12px",
  textAlign: "center",
});

const api = new CampaignApi(apiConfiguration);

const getPreview = async (id: string) => {
  const preview = await api.getCampaignBookingAsync({ id });
  if (preview) {
    return preview;
  }

  return null;
};

const getCampaign = async () => {
  const campaign = await api.getActiveCampaignBookingBySiteAsync();

  if (campaign) {
    return campaign;
  }

  return null;
};

const SubscribeModal: React.FC<{
  root: Root;
  container: HTMLElement;
  onDismiss: (didSubscribe: boolean) => void;
  location?: string;
  campaignId?: string;
}> = (props) => {
  const [shown, setShown] = useState(false);

  const detach = (didSubscribe: boolean) => {
    props.root.unmount();
    props.container.parentNode?.removeChild(props.container);

    if (didSubscribe) {
      Cookies.set(CookieKeys.EmailSubscribed, "true", { expires: 365 });
    } else {
      Cookies.set(CookieKeys.SuppressSlideUp, "true", { expires: 3 });
    }

    props.onDismiss(didSubscribe);
  };

  const [campaign, setCampaign] = useState<CampaignBookingDto | undefined>();

  useEffect(() => {
    (async () => {
      try {
        if (props.campaignId) {
          const result = await getPreview(props.campaignId);

          if (result) {
            setCampaign(result);
          }
        } else {
          //ID is not set
          //setCampaign(await getCampaign());
        }
      } catch (e) {
        //ID is invalid
        try {
          //setCampaign(await getCampaign());
        } catch (e) {
          setCampaign(undefined);
        }
      }
      setShown(true);
    })();
  }, [props.campaignId]);

  return (
    <>
      <SlideUpContainer
        style={{ transform: shown ? `translateY(10%)` : `translateY(-100%)` }}
        onClick={(e) => e.stopPropagation()}
      >
        <BoxContainer>
          <SlideUpBox className="shadow p-4">
            {campaign ? (
              <CornerIcon
                className="shadow"
                dangerouslySetInnerHTML={{ __html: campaign.prize! }}
              ></CornerIcon>
            ) : (
              <></>
            )}
            <button
              type="button"
              onClick={() => detach(false)}
              className="close pl-3 pb-3 text-primary"
              style={{ opacity: 1 }}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            {campaign ? (
              <h5 dangerouslySetInnerHTML={{ __html: campaign.title! }}></h5>
            ) : (
              <h5>Modtag gratis nyheder fra {clientConfiguration.site.name}</h5>
            )}

            {campaign ? (
              <p dangerouslySetInnerHTML={{ __html: campaign.body! }}></p>
            ) : (
              <p>
                Tilmeld dig VORES nyhedsbrev og få nyheder og lokaltilbud
                direkte i indbakken hver uge.
              </p>
            )}
            <EmailSubscribeForm
              location={props.location || "SlideUp"}
              onSubscribed={() => {
                setTimeout(() => {
                  detach(true);
                }, 1500);
              }}
              hasAutofocus={true}
            />
          </SlideUpBox>
        </BoxContainer>
      </SlideUpContainer>
    </>
  );
};

let isModalVisible = false;

export const showSubscribeModal = (
  location?: string,
  onDismis?: (didSubscribe: boolean) => void,
  campaignId?: string
) => {
  if (!isModalVisible) {
    const containerElement = document.createElement("div");
    document.body.appendChild(containerElement);
    const root = createRoot(containerElement);
    root.render(
      <SubscribeModal
        root={root}
        container={containerElement}
        onDismiss={(didSubscribe: boolean) => {
          isModalVisible = false;
          if (onDismis) {
            onDismis(didSubscribe);
          }
        }}
        location={location}
        campaignId={campaignId}
      />
    );

    isModalVisible = true;
  }
};
